import { TabFilter } from 'components/tab-filter/tab-filter';
import { ITabItem } from 'components/tab-filter/tab-item/tab-item';
import React from 'react';
import { useIntl } from 'react-intl';
import styles from '../subsidy-overview.module.scss';

export const SubsidyStatusFilter = ({
	status,
	onStatusTabChange
}: {
	status: string;
	onStatusTabChange: (item: ITabItem) => void;
}): React.JSX.Element => {
	const intl = useIntl();

	return (
		<div className={styles.tabs}>
			<TabFilter
				title={intl.formatMessage({ id: 'modules.highlight.subsidies' })}
				tabItems={[
					{
						id: 'open',
						label: intl.formatMessage({ id: 'subsidy.status.open' })
					},
					{
						id: 'closed',
						label: intl.formatMessage({ id: 'subsidy.status.closed' })
					},
					{
						id: 'almost_opened',
						label: intl.formatMessage({ id: 'subsidy.status.almost_opened' })
					}
				]}
				onChange={onStatusTabChange}
				selectedTabItem={{
					id: status,
					label: intl.formatMessage({ id: `subsidy.status.${status}` })
				}}
			/>
		</div>
	);
};
